// Core packages
import { Component, Inject } from "@angular/core";

// Third party packages
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { take } from "rxjs/operators";

// Custom packages
import { AddCommunicationDialogComponent } from "src/app/shared/components/dialogs/add-communication-dialog/add-communication-dialog.component";

/**
 * Script start
 */
@Component({
  selector: "privacy-docs-link-dialog",
  templateUrl: "./privacy-docs-link-dialog.component.html",
  styleUrls: ["./privacy-docs-link-dialog.component.scss"]
})
export class PrivacyDocsLinkDialogComponent {
  link = "";

  /**
   * Class constructor
   */
  constructor(
    public dialogRef: MatDialogRef<PrivacyDocsLinkDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private translateService: TranslateService,
    private toastrService: ToastrService,
  ) {
    if (this.data && this.data.data && this.data.data.link) {
      this.link = this.data.data.link;
    }
  }

  /**
   * Handle dialog closing
   *
   * @since 1.0.0
   */
  onClose(): void {
    this.dialogRef.close();
  }

  /**
   * Select the whole link content in the input, so the user
   * can copy it with a single click + ctrl/cmd+C
   *
   * @since 1.0.0
   */
  onSelectLink(event: any): void {
    if (event && event.target && typeof event.target.select === "function") {
      event.target.select();
    }
  }

  /**
   * Handle link send by email
   *
   * @since 1.0.0
   */
  onSendLinkByEmail(): void {
    let body = this.translateService.instant('companies.detail.privacyDocsCard.body1');
    body = `${body}\n\n<a href="${this.link}">${this.link}</a><br>`;
    body = `${body}\n\n${this.translateService.instant('companies.detail.privacyDocsCard.body2')}`;

    // Open dialog
    const newDialogRef = this.dialog.open(
      AddCommunicationDialogComponent,
      {
        minWidth: "60%",
        maxHeight: "98vh",
        data: {
          subject: this.translateService.instant('companies.detail.privacyDocsCard.subject'),
          body,
        },
        disableClose: true,
      }
    );

    // Subscribe to dialog result (only for 1 emit thanks to "take()")
    newDialogRef
      .beforeClosed()
      .pipe(take(1))
      .subscribe((res) => {
        if (!res) {
          return;
        }
        this.toastrService.success(
          this.translateService.instant("communications.add.sendedSuccessfully")
        );
      });
  }

}
